/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Unavailable_ErrorsInputs */

const en_model_unavailable_errors = /** @type {(inputs: Model_Unavailable_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temporarily unavailable`)
};

const id_model_unavailable_errors = /** @type {(inputs: Model_Unavailable_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sementara tidak tersedia`)
};

/**
* | output |
* | --- |
* | "Temporarily unavailable" |
*
* @param {Model_Unavailable_ErrorsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const model_unavailable_errors = /** @type {((inputs?: Model_Unavailable_ErrorsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Unavailable_ErrorsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_model_unavailable_errors(inputs)
	return en_model_unavailable_errors(inputs)
});